export default __webpack_public_path__ + "ed57b4f0bd2fbd5a3c4b57559123d036.png";